import React from 'react';
import CardImage from '../../../ui/CardImage';
import { boardCardRotation, cardImageProps } from '../utils/cardView';
import './DragOverlayCard.css';

/**
 * Gezogene Karte im `<DragOverlay>` von dnd-kit, in Brettgröße.
 *
 *   <DragOverlay dropAnimation={null}>
 *     {dnd.activeCard && <DragOverlayCard card={dnd.activeCard} sizePx={cardSizePx} offset={dnd.overlayOffset} />}
 *   </DragOverlay>
 *
 * dnd-kit legt die Overlay-Hülle in Größe der Quelle (Handkarte, Zonen-Kachel …) über den Zeiger.
 * Die Karte sitzt in deren Mitte plus `offset` (aus `usePlaytestDnd`) — genau dort, wo sie beim
 * Loslassen auf der Brettfläche landet. `dropAnimation={null}`, weil die abgelegte Karte selbst
 * über ihr `layoutId` an den neuen Platz gleitet. Verdeckte Karten zeigen den Kartenrücken,
 * Die Karte liegt in der Lage, in der sie auf dem Brett landet
 * (`boardCardRotation`): getappte Brettkarten und quer liegende Seiten (Battles) bleiben quer.
 */
export default function DragOverlayCard({ card, sizePx, offset = { x: 0, y: 0 } }) {
  return (
    <div
      className="drag-overlay-card"
      style={{
        width: sizePx,
        transform: `translate(-50%, -50%) translate(${offset.x}px, ${offset.y}px) rotate(${boardCardRotation(card)}deg)`,
      }}
    >
      {card.faceDown ? <CardImage.Back label="Verdeckte Karte" /> : <CardImage {...cardImageProps(card)} />}
    </div>
  );
}
